// Animation, handed to the views. The browser's own Web Animations, or none
// at all (a test, or a player who asks the system for less motion).

export type Frames = readonly Keyframe[]
export type Motion = {
  readonly reduced: boolean
  readonly animate: (el: Element, frames: Frames, options: KeyframeAnimationOptions) => Promise<void>
}

const settled = async (a: Animation): Promise<void> => {
  try {
    await a.finished
  } catch {
    // cancelled when the element left the page: nothing to wait for
  }
}

export const browserMotion = (): Motion => {
  const reduced = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches
  return {
    reduced,
    animate: (el, frames, options) => (typeof el.animate === "function" ? settled(el.animate([...frames], options)) : Promise.resolve()),
  }
}

// Every animation ends at once. For tests, and for the teaser's fast mode.
export const stillMotion = (): Motion => ({ reduced: true, animate: () => Promise.resolve() })
